import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PreventGuard implements CanActivate {
  constructor(
    private _router: Router,
    private auth: AuthService
  ) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.auth.isAuthenticated() && window.location.pathname != '/logout-all-session') {
        this._router.navigate([`dashboard`]);
        return false;
      }else{
        this.auth.loginIndicator.next(0);
      }
      return true;
  }
  
}
